<template>
  <div class="container">
    <div class="rate">
      <p>评分</p>
      <div style="display:flex;align-items:center;">
        <van-rate v-model="value" color="#ffd21e"/>
        <span style="margin-right:2em;" v-show="value == 1">极差</span>
        <span style="margin-right:2em;" v-show="value == 2">失望</span>
        <span style="margin-right:2em;" v-show="value == 3">一般</span>
        <span style="margin-right:2em;" v-show="value == 4">满意</span>
        <span v-show="value == 5">非常满意</span>
      </div>
    </div>
    <!-- <textarea name="txt" id="" cols="48" rows="10" placeholder="说点什么吧..." v-model="txt"></textarea> -->
    <van-field
      v-model="txt"
      rows="2"
      autosize
      type="textarea"
      maxlength="150"
      placeholder="说点什么吧"
      show-word-limit
    />
    <van-button :loading="loading" type="warning" loading-text="加载中..." @click="submit">提交</van-button>
  </div>
</template>
<script>
export default {
  name:'wishrate',
  data() {
    return{
      value:5,
      loading:false,
      txt:'',
    }
  },
  methods:{
    submit(){
      this.loading = true;
      if(this.value == 0){
        this.$toast('请评星级');
        this.loading = false;
        return;
      }
      this.$axios({
        method:'post',
        url:'/api/task/comment_wish',
        data:this.qs.stringify({
          zjy_uid:sessionStorage.getItem('uid'),
          wish_id:this.$route.query.id,
          comment:this.txt,
          star:this.value,
        })
      }).then(res => {
        console.log(res.data);
        this.loading = false;
        if(res.data.code == 0){
          this.$toast('评分成功');
          this.$router.push('/mywish');
        }else{
          this.$toast(res.data.msg);
        }
      })
    }
  }
}
</script>
<style scoped>
.rate{
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
}
textarea{
  margin: 10px 15px;
  background: #F4F4F4;
  color: #a1a1a1;
  outline: none;
  border-radius: 5px;
  border: none;
  display: block;
  padding: 10px;
}
.van-button{
  width: 80%;
  margin: 45px auto;
  display: block;
  background: #CAB586;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/wishrate.vue